import React from 'react';

import { FormItem, FormItemProps } from '@components/Forms/FormItem';
import {
  ManagementBaseProps,
  ManagementLabel,
  useManagementFormStyles,
} from '@components/Forms/managementCommon';
import { useCommonStyles } from '@styles';

export interface ManagementFormItemProps extends FormItemProps, ManagementBaseProps {}

export const ManagementFormItem: React.FC<React.PropsWithChildren<ManagementFormItemProps>> = (
  props,
) => {
  const classes = {
    ...useCommonStyles(),
    ...useManagementFormStyles(),
  };

  const { children } = props;

  return (
    <div className={classes.container}>
      <FormItem
        classes={{
          label: classes.label,
        }}
        {...props}
        label={<ManagementLabel {...props} />}
      >
        {children}
      </FormItem>
    </div>
  );
};
